import CardTip from './cardTip';
export default {
  name: 'CardReportDesc',
  props: {
    userInfo: Object,
    reportState: Number
  },
  components: {
    'card-tip': CardTip
  },
  data: function data() {
    return {
      textReason: '',
      tipInfo: ''
    };
  },
  watch: {
    textReason: function textReason(val) {
      if (val && val.length >= 100) {
        // console.log('11111ffff', val);
        this.textReason = val.substr(0, 100);
        this.showTip();
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    showTip: function showTip() {
      var _this = this;
      this.tipInfo = "".concat(this.$t('liveroom.personalCard.reportTextNum'));
      setTimeout(function () {
        _this.tipInfo = '';
      }, 1000);
    },
    closeReport: function closeReport() {
      this.$emit('closeReport');
    },
    sendReport: function sendReport() {
      if (!this.textReason) {
        return;
      }
      if (this.textReason && this.textReason.length <= 100) {
        // tuid, uid, type, content
        this.$emit('feedbackSend', this.reportState, this.textReason);
      } else {
        this.showTip();
      }
    }
  }
};